<template>
  <div class="app-content container center-layout mt-2">
      <div class="content-wrapper">
        <div class="content-body">
            <!-- start -->
            <section id="horizontal-form-layouts">

                <div class="row">
                    <div class="col-md-12">
                             
                    </div>
                    <div class="col-md-12">
                        <div class="card border-blue-grey border-lighten-4 box-shadow-1">
                            <div class="card-header">
                                <h4 class="card-title text-center" id="horz-layout-basic">REGISTRATION FOR UG@70 ALUMNI HOMECOMING</h4> 
                                <hr>
                            </div>
                            <div class="card-content collpase show">
                                <div class="card-body">
                                    <div class="card-text">
                                        <img src="assets/images/banner.jpg" alt="banner" style="width:100%">
                                        <div class="card p-2 box-shadow-1 border-primary border-darken-1">
                                            <h4 class="text-center">CountDown</h4>
                                            <div class="col-sm-6 offset-sm-3">
                                            <div id="timer" class="timer">
                                            <Timer 
                                                    starttime="Jun 7, 2019 00:00:00" 
                                                    endtime="Aug 9, 2019 00:00:00" 
                                                    trans='{  
                                                    "day":"Days",
                                                    "hours":"Hours",
                                                    "minutes":"Minutes",
                                                    "seconds":"Seconds",
                                                    "expired":"Event has been expired.",
                                                    "running":"Till start of event.",
                                                    "upcoming":"Till start of event.",
                                                    "status": {
                                                        "expired":"Expired",
                                                        "running":"Running",
                                                        "upcoming":"Future"
                                                    }}'
                                                    ></Timer>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h3 class="text-center">All fields marked with <span style="color:red">*</span> are mandatory</h3>
                                    <form class="form form-horizontal" @submit.prevent="submitForm">
                                        <div class="form-body">
                                            <h4 class="form-section">PERSONAL INFORMATION</h4>
                                             <div class="form-group row">
                                                <label class="col-md-3 label-control" for="title">Title <span style="color:red">*</span></label>
                                                <div class="col-md-6">
                                                    <select name="title" id="title" class="form-control" v-model="formdata.title" v-validate="'required'" data-vv-as="Title">
                                                        <option value="">Select Title</option>
                                                        <option v-for="(t,index) in titles" :value="t" :key="index">{{t}}</option>
                                                    </select>
                                                    <span style="color:red;font-style:italic">{{ errors.first('title') }}</span>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-3 label-control" for="firstname">First Name <span style="color:red">*</span></label>
                                                <div class="col-md-6">
                                                    <input type="text" id="firstname" class="form-control" placeholder="First Name" name="firstname" v-model="formdata.firstname" v-validate="'required'" data-vv-as="Firstname">
                                                    <span style="color:red;font-style:italic">{{ errors.first('firstname') }}</span>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-3 label-control" for="surname">Surname <span style="color:red">*</span></label>
                                                <div class="col-md-6">
                                                    <input type="text" id="surname" class="form-control" placeholder="Surname" name="surname" v-model="formdata.surname" v-validate="'required'" data-vv-as="Surname">
                                                    <span style="color:red;font-style:italic">{{ errors.first('surname') }}</span>
                                                </div>
                                            </div>

                                             <div class="form-group row">
                                                <label class="col-md-3 label-control" for="othernames">Other Names</label>
                                                <div class="col-md-6">
                                                    <input type="text" id="othernames" class="form-control" placeholder="Other Names" name="othernames" v-model="formdata.othernames">
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-3 label-control" for="email">E-mail <span style="color:red">*</span></label>
                                                <div class="col-md-6">
                                                    <input type="email" id="email" class="form-control" placeholder="E-mail" name="email" v-model="formdata.email" v-validate="'required|email'" data-vv-as="Email" onselectstart="return false" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false">
                                                    <span style="color:red;font-style:italic">{{ errors.first('email') }}</span>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-3 label-control" for="phone">Contact Number <span style="color:red">*</span></label>
                                                <div class="col-md-6">
                                                    <input type="text" id="phone" class="form-control" placeholder="Contact Number" name="phone" v-model="formdata.phone" v-validate="'required'" data-vv-as="Phone Number">
                                                    <span style="color:red;font-style:italic">{{ errors.first('phone') }}</span>
                                                </div>
                                            </div>
                            
                                            <h4 class="form-section">OTHER INFORMATION</h4>

                                            <div class="form-group row">
                                                <label class="col-md-3 label-control" for="yearofgraduation">Year Of Graduation <span style="color:red">*</span></label>
                                                <div class="col-md-6">
                                                   <select name="yearofgraduation" id="yearofgraduation" class="form-control" v-model="formdata.yearofgraduation" v-validate="'required'" data-vv-as="Graduation Year">
                                                       <option value="">Please Select Year</option>
                                                        <option v-for="y in range(1940, 2019)" :value="y" :key="y">{{y}}</option>
                                                   </select>
                                                    <span style="color:red;font-style:italic">{{ errors.first('yearofgraduation') }}</span>
                                                </div>
                                            </div>

                                              <div class="form-group row">
                                                <label class="col-md-3 label-control" for="degree">Degree</label>
                                                <div class="col-md-6">
                                                    <label class="d-inline-block custom-control custom-checkbox col-sm-12 col-md-3 col-xs-12 col-lg-3" v-for="(d,index) in degrees" :key="index">
                                                        <input type="checkbox" name="degree" class="custom-control-input" :value="d" v-model="formdata.degree">
                                                        <span class="custom-control-indicator"></span>
                                                        <span class="custom-control-description">{{d}}</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-3 label-control" for="hall">Hall of Affiliation <span style="color:red">*</span></label>
                                                <div class="col-md-6">
                                                    <select id="hall" name="hall" class="form-control" v-model="formdata.hall" v-validate="'required'" data-vv-as="Hall">
                                                        <option value="">Please Select</option>
                                                        <option v-for="(h,index) in halls" :value="h" :key="index">{{h}}</option>             
                                                    </select>
                                                     <span style="color:red;font-style:italic">{{ errors.first('hall') }}</span>
                                                </div>
                                            </div>

                                            <h4 class="form-section" style="color:red">PLEASE CLICK ON EACH TICKET TO SEE ITS DETAILS.</h4>
                                            <div class="form-group row">
                                                <label class="col-md-3 label-control" for="ticket">Type of ticket. <span style="color:red">*</span></label>
                                                <div class="col-md-6">
                                                    <fieldset v-for="(i,index) in ticketstype" :key="index">
                                                        <label class="custom-control custom-radio">
                                                        <input name="ticket" type="radio" class="custom-control-input" :value="i.name+'::'+i.value" v-model="formdata.ticket" @change="showDetails(index,i.name)">
                                                        <span class="custom-control-indicator"></span>
                                                        <span class="custom-control-description">{{i.label}}</span>
                                                        </label>
                                                        <p style="padding:15px;border:1px dashed #f78803;font-weight:bolder" v-show="desc[index]===index" v-html="i.description"></p>
                                                    </fieldset>
                                                </div>
                                            </div>

                                              <div class="form-group row" v-if="formdata.ticket.indexOf('DAY PASS') !== -1">
                                                <label class="col-md-3 label-control" for="daypass">Select Days</label>
                                                <div class="col-md-6">
                                                    <label class="d-inline-block custom-control custom-checkbox col-sm-12 col-md-12 col-xs-12 col-lg-12" v-for="(d,index) in daypasstypes" :key="index">
                                                        <input type="checkbox" name="daypasstype" class="custom-control-input" :value="d.value" v-model="formdata.daypasstype">
                                                        <span class="custom-control-indicator"></span>
                                                        <span class="custom-control-description">{{d.label}}</span>
                                                    </label>
                                                </div>
                                            </div>
                                            
                                           
                                        </div>
                                        <div class="form-actions center">
                                            <!-- <button type="button" class="btn btn-warning mr-1">
                                                <i class="ft-x"></i> Cancel
                                            </button> -->
                                            <button type="submit" class="btn btn-ug btn-lg box-shadow-1">
                                                <i class="fa fa-check-square-o"></i> Save and Continue
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- end -->
        </div>
      </div>
    </div>
</template>

<script>
import Timer from './components/Timer.vue';
export default {
  name: 'Content',
   props:{
      formdata:{
          type:Object,
        //   default:{
        //       title:'',
        //       surname:'',
        //       othernames:'',
        //       firstname:'',
        //       email:'',
        //       phone:'',
        //       degree:[],
        //       daypasstype:[],
        //       ticket:'',
        //       yearofgraduation:'',
        //       hall:''
        //   }
      }
  },
  components:{
      Timer
  },
  data() {
      return {
            desc:{},
          ticketstype:[
              {label:'V.I.P - GHS 750.00',name:'V.I.P',value:750,description:`Ticket covers<br>  
                        - 3 nights accommodation  in single occupancy en-suite room<br>   
                        - 1x3 days breakfast <br>
                        - 1x3 days other meal voucher<br>
                        - full access to all activities in the programme <br>
                        - 1 VIP welcome kit<br>
                        - Preferred seating at most activities(where applicable)`},

              {label:'EXECUTIVE - GHS 450.00',name:'EXECUTIVE',value:450,description:`
                    Ticket covers<br>
                    - 3 nights accommodation in single occupancy with shared facilities<br>
                    - 1×3 days breakfast<br>
                    - 1×3 days other meal voucher<br>
                    - full access to all activities in the programme
              `},
              {label:'STANDARD - GHS 350.00',name:'STANDARD',value:350,description:`
                Ticket covers<br>
                - 3 nights accommodation in shared occupancy (2 in a room) with shared facilities<br>
                - 1×3 days breakfast<br>
                - 1×3 days other meal voucher<br>
                - full access to all activities in the programme
              `},
              {label:'FAMILY RATE - GHS 1400.00',name:'FAMILY RATE',value:1400,description:`Ticket covers<br>  
                    - 2x3 nights accommodation. (1 room for adults) plus 3 in a room(for 3 children under 15).<br>
                    - 5×3 days breakfast<br>
                    - 5×3 days other meal voucher<br>
                    - full access to all activities in the programme<br>`},

               {label:'B. PACK - GHS 240.00',name:'B. PACK',value:240,description:`
                Ticket covers<br>
                - 3 nights accommodation in shared occupancy (4 in a room) with shared facilities<br>
                - 1×3 days breakfast<br>
                - 1×3 days other meal voucher<br>
                - full access to all activities in the programme
              `},
                
              {label:'DAY PASS - GHS 70.00',name:'DAY PASS',value:70,description:`
              Ticket covers<br>
                - access to activities in the programme for selected day only<br>
                <span style="font-weight:bold">Note</span> : Day Passes are not interchangeable (a Day Pass for one day may not be used for a different day).  
              `}
          ],
          titles:[         
            'Mr.',
            'Mrs.',
            'Ms.',
            'Rev.',
            'Rev. Sr.',
            'Dr.',
            'Prof',
            'Imam'
          ],
          showdaypass:false,
          daypasstypes:[
            {label:'Friday 9th, August 2019',value:'Friday'},
            {label:'Saturday 10th, August 2019',value:'Saturday'},
            {label:'Sunday 11th, August 2019',value:'Sunday'}
          ],
          degrees:[
              'PhD', 'MPhil', 'MSc','EMBA', 'MBA','MPH','MPA', 'MA', 'MBChB', 'BSc','LLB','LLM','BSc Admin', 'BA', 'BPH','Diploma', 'Certificate'
          ],
          halls:[
              'Legon Hall',
              'Akuafo Hall',
              'Volta Hall',
              'Common Wealth Hall',
              'Jubilee Hall',
              'Mensah Sarbah Hall',
              'Hilla Limann Hall',
              'Alex Adum Kwapong Hall',
              'Jean Nelson Hall',
              'Elizabeth Frances Sey Hall',
              'African Union Hall',
              'Valco Hall',
              'International Students Hall',
              'Evandy Hostel',
              'Bani Hostel',
              'James Top Nelson Yankah Hall',
              'Non Resident'
          ],
        //   formdata:{
        //       title:'',
        //       surname:'',
        //       othernames:'',
        //       firstname:'',
        //       email:'',
        //       phone:'',
        //       degree:'',
        //       ticket:'',
        //       yearofgraduation:'',
        //       hall:''

        //   }
      }
  },
  methods: {
      range: function(min,max){
            var array = [],
            j = 0;
            for(var i = max; i >= min; i--){
            array[j] = i;
            j++;
            }
            return array;
     },
     showDetails(index,type=null){
         this.desc = {};
         this.desc[index] = index;
         this.showdaypass = false;
         if(type && type==='DAY PASS'){
             this.showdaypass = true;
         }else{
             //console.log('here');
             this.formdata.daypasstype = [];
         }
     },
     submitForm:function(){
         this.$validator.validate().then(valid => {
           if (valid) {
               var _this = this;
             if(this.formdata.ticket !==''){
                  if(this.formdata.ticket.indexOf('DAY PASS') !== -1 && this.formdata.daypasstype.length===0){
                      this.$swal('Alert','Please select your days for the Day Pass Ticket Option ','info');
                        return;
                  }
                  this.$swal({
                      title:"Confirm Email Address",
                        content: {
                            element: "input",
                            attributes: {
                            placeholder: "Please confirm your Email Address",
                            type: "email",
                            },
                        },
                        }).then(res=>{
                            if(res){
                                if(res.trim() !== _this.formdata.email.trim()){
                                 this.$swal('Alert','Sorry this email does not match the previous email you entered','info');
                            }else{
                                 this.$emit('onformsubmit',this.formdata);
                            }
                            }else{
                                 this.$swal('Alert','Enter a valid email address','info');
                            }
                            
                        });
                  
                    //this.$emit('onformsubmit',this.formdata);
             }else{
                 this.$swal('Alert','Please choose Ticket Type','info');
             }
         }
      });
      
     }
  },
}
</script>
<style scoped>

</style>
